// extracted by mini-css-extract-plugin
module.exports = {"root":"EventCard__root--3trSw","bounce":"EventCard__bounce--1xETz"};